<div class="layout-container">
    <h2 class="heading-lg">Prototyping Offer</h2>
    <hr />
    <p class="text-block">
      SSPPL offers a wide range of Rapid Prototyping & 3D Printing Services.
      We provide Design and Drafting services to help you turn your ideas into 3D Designs or Models using the best 
      design software. We can test the fit and function of your product in our software using 3D Assembly & Modelling.
    </p>
    
    <strong>Advantages of 3D Printing:</strong>
    <ul class="custom-bullet-list">
      <li>Customized and fast development</li>
      <li>Reduces prototyping costs</li>
      <li>Accelerates design iteration and validation</li>
      <li>Enables production of complex geometries</li>
    </ul>
  
    <strong>Disadvantages of 3D Printing:</strong>
    <ul class="custom-bullet-list">
      <li>Material limitations</li>
      <li>Not ideal for high-volume manufacturing</li>
      <li>Surface finish may require post-processing</li>
      <li>Longer print time for large models</li>
    </ul>
  </div>
  
